var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isButton)?_c('button',{class:_vm.classButton,attrs:{"disabled":_vm.disabled},on:{"click":_vm.action}},[_vm._t("default")],2):_c('a',{staticClass:"link",on:{"click":_vm.action}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }